<template>
  <div>
    <EmulatorSectionHeader title="Fonts" />

    <div v-for="group in fontGroups" :key="group.category">
      <h4 class="mt-4 mb-3">{{ group.category }}</h4>
      <template v-for="field in group.fields">
        <EmulatorCustomizationDropdown
          v-if="field.inputType === 'dropdown'"
          :key="`dropdown-${field.path}`"
          :category="group.category"
          :label="field.label"
          namespace="theme"
          :path="field.path"
          dataType="string"
          :options="fontNameList"
          :selectionChangedHandler="onFontCustomization"
        />
        <EmulatorCustomizationTextBox
          v-else
          :key="`textbox-${field.path}`"
          :category="group.category"
          :label="field.label"
          namespace="theme"
          :path="field.path"
          :dataType="field.dataType"
          :placeholder="field.placeholder"
        />
      </template>
    </div>
  </div>
</template>

<script>
import EmulatorSectionHeader from '@/components/Modules/Emulator/EmulatorSectionHeader'
import EmulatorCustomizationDropdown from '@/components/Modules/Emulator/CustomizationInputs/EmulatorCustomizationDropdown'
import EmulatorCustomizationTextBox from '@/components/Modules/Emulator/CustomizationInputs/EmulatorCustomizationTextBox'
import { EMULATOR_EVENT_TYPES } from '@/utils/constants'
import { mapState } from 'vuex'
import { requestDataFromTransact } from '@/utils/emulator'

// Theme typography fields, grouped by the section header they appear under.
// All `path`s are relative to the `theme` namespace.
const FONT_GROUPS = [
  {
    category: 'Headings',
    fields: [
      {
        label: 'Font Family',
        path: 'typography.heading.fontFamily',
        inputType: 'dropdown',
        dataType: 'string',
      },
    ],
  },
  {
    category: 'Body',
    fields: [
      {
        label: 'Font Family',
        path: 'typography.body.fontFamily',
        inputType: 'dropdown',
        dataType: 'string',
      },
    ],
  },
  {
    category: 'Buttons',
    fields: [
      {
        label: 'Font Family',
        path: 'typography.button.fontFamily',
        inputType: 'dropdown',
        dataType: 'string',
      },
      // Disabled until the new theme structure is fully wired up end-to-end.
      // {
      //   label: 'Font Weight',
      //   path: 'typography.button.fontWeight',
      //   dataType: 'string',
      //   placeholder: '400',
      // },
    ],
  },
]

export default {
  name: 'EmulatorFonts',
  components: {
    EmulatorSectionHeader,
    EmulatorCustomizationDropdown,
    EmulatorCustomizationTextBox,
  },
  computed: {
    ...mapState('emulator', ['supportedFonts']),
    fontGroups() {
      return FONT_GROUPS
    },
    fontNameList() {
      return this.supportedFonts.map((font) => font.label)
    },
  },
  methods: {
    onFontCustomization({ label, value }) {
      this.$analytics.track({
        event: 'Font Customization',
        payload: { fontArea: label, fontName: value },
      })
    },
  },
  mounted() {
    requestDataFromTransact({
      eventType: EMULATOR_EVENT_TYPES.GET_SUPPORTED_FONTS,
      payload: {
        pathToVuexData: 'defaults.fonts.supportedFonts',
        namespace: 'theme',
        storeActionPath: 'emulator/updateSupportedFonts',
      },
    })
  },
}
</script>
